import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    onSendMessage: (displayUniqueIdentifier, MessageId, data) => async (dispatch, store) => {
        let CommandData = "";
        if (data) {CommandData = "/" + data;}

        let MessageName = null;
        switch (MessageId) {
            case 10 : MessageName = "CreateRestartDisplayMessage"; break;
            case 20 : MessageName = "CreateRestartPlayerMessage"; break;
            case 30 : MessageName = "CreateReloadContentMessage"; break;
            case 60 : MessageName = "CreatePowerOffMessage"; break;
            case 70 : MessageName = "CreateGetScreenShotMessage"; break;
            case 80 : MessageName = "CreateSetVolumeUpMessage"; break;
            case 85 : MessageName = "CreateSetVolumeUpMessage"; break;
            case 90 : MessageName = "CreateSetVolumeDownMessage"; break;
            case 100 : MessageName = "CreateMuteMessage"; break;
            case 110 : MessageName = "CreateUnMuteMessage"; break;
            case 120 : MessageName = "CreateShowLogsMessage"; break;
            case 130 : MessageName = "CreateHideLogsMessage"; break;
            case 140 : MessageName = "CreateSendLogMessage"; break;
            case 150 : MessageName = "CreateShowInfoMessage"; break;
            case 160 : MessageName = "CreateHideInfoMessage"; break;
            case 170 : MessageName = "CreateLockSecurityMessage"; break;
            case 180 : MessageName = "CreateUnlockSecurityMessage"; break;
            case 190 : MessageName = "CreateStreamLogsMessage"; break;
        }

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Messages/" + MessageName + "/" + displayUniqueIdentifier + CommandData, {
            method: "GET"
        }).then(() => {
            toast.success(strings.messageSent);
        }).catch( (data) => {
            console.log(data);
        });
    }
};
